<template>
  <b-container fluid class="relatorio">
    <span class="premium-tag" @click="showModalPremium('show')">
      <i class="far fa-star"></i>&nbsp;
      <b>Premium</b>
    </span>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      type="border-card"
    >
      <el-tab-pane label="Status" name="status">
        <b-row>
          <div class="col-lg-12 col-md-12 mt-2">
            <RelatorioLegenda />
            <RelatorioFiltro @atualizarLista="atualizarLista" />
            <RelatorioStatus :filtros="filtros" />
          </div>
        </b-row>
      </el-tab-pane>
    </el-tabs>
  </b-container>
</template>

<script>
import RelatorioStatus from './RelatorioStatus'
import RelatorioFiltro from './RelatorioFiltro/RelatorioFiltro.vue'
import RelatorioLegenda from './RelatorioLegenda.vue'

export default {
  components: {
    RelatorioStatus,
    RelatorioFiltro,
    RelatorioLegenda
  },
  data() {
    return {
      activeName: 'status',
      filtros: {}
    }
  },
  methods: {
    handleClick(tab) {
      if (tab.paneName === "status") {
        this.$root.$emit('tabStatus')
      }
    },
    atualizarLista(filtrosAtualizados) {
      this.filtros = { ...filtrosAtualizados }; // Atualiza os filtros no estado
    },
  }
}
</script>

<style lang="scss">
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.relatorio .el-select .el-input {
  width: 250px;
}
</style>
